<template>
  <CustomIonModalContent v-if="ModalProps" :modalProps="ModalProps">
    <template #contentSlot>
      <div class="text-m px-5 py-4">
        <div class="font-semibold color-tertiary"><i class="ti ti-menu-2 me-2"></i>More</div>
      </div>
      <div class="pb-2">
        <CustomSimpleButton
          v-for="(option, index) in options"
          :key="option.ViewRoute || option.MenuName"
          class="more-row px-3 py-2 mx-1 cursor-pointer"
          :class="{ 'more-row--divider': index < options.length - 1 }"
          :ariaLabel="option.FooterTitle || option.DisplayTitle || undefined"
          @onClick="onSelectOption(option)"
        >
          <span class="row-center w-full gap-4">
            <span
              class="center-xy shrink-0 h-10 w-10 rounded-xl color-light shadow-card"
              :class="`bg-color-${option.FooterColor ?? 'primary'}-dark`"
            >
              <i
                class="text-xl leading-none"
                :class="getTablerIconClass(option.FooterIcon ?? option.MenuIcon)"
                aria-hidden="true"
              ></i>
            </span>
            <span class="flex min-w-0 flex-1 flex-col gap-0.5 text-left">
              <span class="text-m font-semibold color-text truncate">
                {{ option.FooterTitle || option.DisplayTitle }}
              </span>
              <span v-if="option.FooterSubtitle" class="text-xxs color-text-light truncate">
                {{ option.FooterSubtitle }}
              </span>
            </span>
            <i
              class="ti ti-chevron-right text-m leading-none color-medium shrink-0"
              aria-hidden="true"
            ></i>
          </span>
        </CustomSimpleButton>
      </div>
    </template>
  </CustomIonModalContent>
</template>

<script lang="ts">
import CustomIonButton from "@/components/primitives/CustomIonButton.vue";
import CustomSimpleButton from "@/components/primitives/CustomSimpleButton.vue";
import CustomIonModalContent from "@/components/ionic/CustomIonModalContent.vue";
import { getTablerIconClass } from "@/methods/utils";
import { useIonModalStore } from "@/stores/core/ionModalStore";
import type { MenuItem } from "@/types/global";
import { storeToRefs } from "pinia";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "FooterNavbarMore",
  components: { CustomIonButton, CustomSimpleButton, CustomIonModalContent },
  props: { options: { type: Array as PropType<MenuItem[]>, default: () => [] } },
  emits: ["select"],
  setup(_, { emit }) {
    const ionModalStore = useIonModalStore();
    const { ModalProps } = storeToRefs(ionModalStore);
    const { dismissModal } = ionModalStore;

    async function onSelectOption(option: MenuItem) {
      emit("select", option);
      await dismissModal();
    }

    async function onClose() {
      await dismissModal();
    }

    return { ModalProps, getTablerIconClass, onSelectOption, onClose };
  },
});
</script>

<style lang="scss" scoped>
.more-row {
  &.more-row--divider {
    border-bottom: 1px solid var(--color-medium-light);
  }
}
</style>
